import { Clock3, ShieldCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import type { ToolRegistryItem } from "@/types/tools";

type ComingSoonToolProps = {
  tool: ToolRegistryItem;
};

export function ComingSoonTool({ tool }: ComingSoonToolProps) {
  return (
    <div className="rounded-lg border border-dashed border-zinc-300 bg-white p-6">
      <div className="mb-4 flex flex-wrap items-center gap-2">
        <Badge variant="warning">
          <Clock3 className="h-3 w-3" />
          Coming soon
        </Badge>
        {tool.localOnly ? (
          <Badge variant="success">
            <ShieldCheck className="h-3 w-3" />
            No uploads planned
          </Badge>
        ) : null}
      </div>
      <h2 className="text-lg font-semibold text-zinc-950">{tool.name}</h2>
      <p className="mt-2 max-w-2xl text-sm leading-6 text-zinc-600">
        This tool is listed in the MVP navigation so the product shape is clear, but
        functionality is not faked. Processing controls will appear here when the real
        local workflow is implemented.
      </p>
    </div>
  );
}
